// DialogTimeCardAdd Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import Select from '../../../common/form/select/select.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Acl from '../../../lib/acl.jsx'

class DialogTimeCardAdd extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bShowTask: false,
      active: false,
      projectId: null,
      activityId: null,
      activity: '',
      activeDate: null,
      taskId: null,
      loading: {
        isLoadingActivities: false
      }
    }

    this.data = {
      projects: _.cloneDeep(props.projects),
      tasks: [],
      normalActivities: [
        { label: 'time.form.activityHoliday', value: 'Holiday' },
        { label: 'time.form.activitySickLeave', value: 'SickLeave' },
        { label: 'time.form.activityMeeting', value: 'Meeting' },
        { label: 'time.form.activityTraining', value: 'Training' },
        { label: 'time.form.activityDoctorOrDentist', value: 'Doctor/Dentist' },
        { label: 'time.form.activityOther', value: 'Other' }
      ],
      disableSubmit: false
    }

    this._references = {
      selectProject: React.createRef(),
      selectActivity: React.createRef()
    }
  }

  static get propTypes () {
    return {
      projects: PropTypes.array,
      currentUser: PropTypes.bool,
      getTasks: PropTypes.func,
      onSubmit: PropTypes.func,
      onSearchActivity: PropTypes.func,
      onConfirmOutsideDate: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      projects: [],
      currentUser: true,
      getTasks: null,
      onSubmit: null,
      onSearchActivity: null,
      onConfirmOutsideDate: null
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    this.data.projects = _.cloneDeep(nextProps.projects)
  }

  toggleLoading (key, isLoading) {
    this.setState(prevState => ({ ...prevState, loading: { ...prevState.loading, [key]: isLoading } }))
  }

  show (projects) {
    FabButtonManager.setVisible(false)
    if (projects !== undefined && projects) {
      this.data.projects = projects
    }
    this.setState({ active: true })
  }

  showAddTimeCard (activeDate) {
    this.setState({ active: true, activeDate: activeDate })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      bShowTask: false,
      projectId: null,
      activityId: null,
      taskId: null,
      activity: ''
    })

    this.data.disableSubmit = false

    if (this._references.selectProject.current) {
      this._references.selectProject.current.clearError()
    }

    if (this._references.selectActivity.current) {
      this._references.selectActivity.current.clearError()
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(false, ev)
    }
  }

  render () {
    const { activity, projectId, activityId, bShowTask, taskId, loading: { isLoadingActivities } } = this.state
    const currentUser = this.props.currentUser
    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        className='dialog-timecardform'
      >
        <div className='dialog-form'>
          <div className='dialogform-header'>
            <div className='title'>
              <IntlMessage ident='time.form.timecardTitle' />
            </div>
            <IconButton
              icon='wizard-close'
              className='modal wizard-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    {currentUser && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.data.projects}
                            name='project'
                            label='time.form.projectLabel'
                            ref={this._references.selectProject}
                            className='form-dropdown'
                            disabled={!!activity}
                            onChange={this._onChangeProject.bind(this)}
                            value={projectId}
                          />
                        </div>
                      </div>
                    )}
                    {currentUser && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.data.activities}
                            name='activity'
                            label='time.form.activityLabel'
                            ref={this._references.selectActivity}
                            className='form-dropdown'
                            disabled={!!activity}
                            onChange={this._onChangeActivity.bind(this)}
                            value={activityId}
                            isLoading={isLoadingActivities}
                          />
                        </div>
                      </div>
                    )}
                    {bShowTask &&
                      Acl.isPlannerAllowed() &&
                      this.data.tasks &&
                      /* eslint-disable indent */
                      this.data.tasks.length > 0 && (
                        <div className='formrow'>
                          <div className='formcol'>
                            <Select
                              options={this.data.tasks}
                              name='task'
                              label='time.form.taskLabel'
                              className='form-dropdown'
                              onChange={this._onChangeTask.bind(this)}
                              value={taskId}
                            />
                          </div>
                        </div>
                      )}
                    <div className='formrow'>
                      <div className='formcol'>
                        <div className='form-activities'>
                          {this._renderActivities()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-saveadd'
              title='time.form.tipSaveAdd'
              className='actsecond'
              canHover={false}
              onClick={
                this.data.disableSubmit
                  ? null
                  : this._onFormSubmit.bind(this, true)
              }
              disabled={this.data.disableSubmit}
            />
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='time.form.tipSave'
              canHover={false}
              onClick={
                this.data.disableSubmit
                  ? null
                  : this._onFormSubmit.bind(this, false)
              }
              disabled={this.data.disableSubmit}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (bOpen, ev) {
    ev.preventDefault()

    if (!this.data.disableSubmit) {
      let noError = 0
      const timeObj = { timeTaken: 0 }

      if (this.state.activity) {
        // If normal activity
        timeObj.projectId = null
        timeObj.activityId = null
        timeObj.activity = this.state.activity
      } else if (!this.state.projectId || !this.state.activityId) {
        noError += 1
      } else {
        // If project and budgetitem set
        timeObj.projectId = this.state.projectId
        timeObj.activityId = this.state.activityId
        timeObj.activity = ''
        const budgetItem = _.find(
          this.data.activities,
          obj => obj.value === this.state.activityId
        )
        if (budgetItem) {
          timeObj.activity = budgetItem.label
        }
      }

      if (this.state.bShowTask) {
        timeObj.taskId = this.state.taskId ? this.state.taskId : null
      }

      // RW-91: If no error, then validate dates and if is outside project date, show confirm
      if (noError === 0) {
        const validateInfo = this._validProjectDates()
        if (
          !validateInfo.isValid &&
          this.state.projectId &&
          this.state.activityId &&
          this.props.onConfirmOutsideDate
        ) {
          noError += 1

          this.props.onConfirmOutsideDate(validateInfo.message, () => {
            this._saveTimeCard(timeObj, bOpen)
          })
        }
      }

      if (noError === 0) {
        this._saveTimeCard(timeObj, bOpen)
      }
    }
  }

  _saveTimeCard (timeObj, bOpen) {
    this.data.disableSubmit = true
    this.setState({ dataDate: new Date() })

    if (this.props.onSubmit) {
      this.props.onSubmit(timeObj, bOpen)
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeTask (taskId) {
    this.setState({ taskId: taskId })
  }

  _onChangeProject (projectId) {
    this.setState({ projectId: projectId })

    const extraQuery = {}
    const project = _.find(this.data.projects, obj => obj.value === projectId)

    if (project && project.activePhaseNos) {
      extraQuery.activePhaseNos = project.activePhaseNos
    }

    this.toggleLoading('isLoadingActivities', true)

    this.props.onSearchActivity(projectId, extraQuery, activities => {
      this.data.activities = activities
      this.forceUpdate()
      this.toggleLoading('isLoadingActivities', false)
    })
  }

  _validProjectDates () {
    const validateInfo = { isValid: true, message: '' }
    const { activeDate } = this.state
    const { activities } = this.data

    if (
      !activeDate ||
      !activities ||
      (activities && activities.length === 0) ||
      !activities[0]
    ) {
      return validateInfo
    }

    const { project } = activities[0]
    if (!project) {
      return validateInfo
    }

    const startDate = Date.parse(project.startDate)
    const endDate = Date.parse(project.endDate)
    const currentDate = Date.parse(activeDate)

    if (
      currentDate &&
      endDate &&
      startDate &&
      (currentDate <= startDate || currentDate >= endDate)
    ) {
      validateInfo.isValid = false
      validateInfo.message = IntlUtil.convertMessage(
        'time.dialog.dialogMessage2',
        {
          startDate: moment(project.startDate).format('D MMMM YYYY'),
          endDate: moment(project.endDate).format('D MMMM YYYY'),
          currentDate: moment(activeDate).format('MMMM D')
        }
      )
    } else if (
      currentDate &&
      !endDate &&
      startDate &&
      currentDate <= startDate
    ) {
      validateInfo.isValid = false
      validateInfo.message = IntlUtil.convertMessage(
        'time.dialog.dialogMessage',
        {
          startDate: moment(project.startDate).format('D MMMM YYYY'),
          currentDate: moment(activeDate).format('MMMM D')
        }
      )
    } else if (currentDate && endDate && !startDate && currentDate >= endDate) {
      validateInfo.isValid = false
      validateInfo.message = IntlUtil.convertMessage(
        'time.dialog.dialogMessage1',
        {
          endDate: moment(project.endDate).format('D MMMM YYYY'),
          currentDate: moment(activeDate).format('MMMM D')
        }
      )
    }

    return validateInfo
  }

  _onActivityClick (activity, e) {
    e.preventDefault()
    if (activity !== this.state.activity) {
      this.setState({ activity: activity, projectId: null, activityId: null })
    } else {
      this.setState({ activity: '' })
    }
  }

  _onChangeActivity (activityId) {
    this.setState({ activityId: activityId, taskId: null })

    this.props.getTasks(this.state.projectId, activityId, tasks => {
      this.data.tasks = tasks
      if (tasks && tasks.length > 0) {
        this.setState({ bShowTask: true })
      }
    })
  }

  /* Private functions */
  _renderActivities () {
    if (this.data.normalActivities && this.data.normalActivities.length > 0) {
      return this.data.normalActivities.map((activity, idx) => {
        let className = 'form-activities-item'
        if (activity.value === this.state.activity) {
          className = 'form-activities-item active'
        }
        const maxChars = 8
        const activityTitle = IntlUtil.convertMessage(`${activity.label}`)
        let newActivityTitle = ''
        activityTitle.split(' ').forEach(word => {
          if (word.length > maxChars) {
            word = `${word.slice(0, maxChars)}- ${word.slice(maxChars)}`
          }

          newActivityTitle += `${word} `
        })

        return (
          <div
            className={className}
            key={idx}
            onClick={this._onActivityClick.bind(this, activity.value)}
          >
            {newActivityTitle}
          </div>
        )
      })
    }

    return ''
  }
}

export default DialogTimeCardAdd
